// In-memory ring buffer of recent activity for the Logs panel; deliberately not persisted.

export type LogLevel =
  | 'info'
  | 'warn'
  | 'error'
  /** A round trip that came back 200. */
  | 'net'
  /** A round trip that came back anything else — highlighted, not hidden. */
  | 'odd';

export interface LogLine {
  seq: number;
  ts: number;
  level: LogLevel;
  source: string;
  msg: string;
}

const MAX = 400;

const lines: LogLine[] = [];
const listeners = new Set<(l: LogLine) => void>();
let seq = 0;

export function log(level: LogLevel, source: string, msg: string): void {
  const line: LogLine = { seq: ++seq, ts: Date.now(), level, source, msg: String(msg).slice(0, 600) };
  lines.push(line);
  if (lines.length > MAX) lines.shift();
  for (const fn of listeners) {
    try {
      fn(line);
    } catch { /* a broken listener must not break the caller */ }
  }
}

export const logInfo = (source: string, msg: string) => log('info', source, msg);
export const logWarn = (source: string, msg: string) => log('warn', source, msg);
export const logError = (source: string, msg: string) => log('error', source, msg);
export const logNet = (source: string, msg: string) => log('net', source, msg);
export const logOdd = (source: string, msg: string) => log('odd', source, msg);

export function logLines(): readonly LogLine[] {
  return lines;
}

export function clearLog(): void {
  lines.length = 0;
}

export function onLog(fn: (l: LogLine) => void): () => void {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
